import React, { useContext } from 'react';
import { LocalizationContext } from 'app/localization/Context';
import Popup, { usePopup } from 'app/home/general-components/Popup/Popup';
import { CurrentPageContext } from 'app/home/general-components/HistoryStackContext';
import CustomIconBack from 'app/home/home-components/CustomIconBack';
import Toggle, { ToggleHeadIconType } from 'app/home/general-components/Toggle/Toggle';
import { WebViewManagerContext } from 'app/home/general-components/WebViewManagerContext';

import { ReactComponent as IconBack } from 'images/general/back.svg';
import { ReactComponent as IconTick } from 'images/general/tick-blue.svg';
import { ReactComponent as IconClearData } from 'images/setting/clear-data.svg';
import { ReactComponent as IconReload } from 'images/setting/reload.svg';
import { ReactComponent as IconNotif } from 'images/bind/element/notif.svg';
import { ReactComponent as IconClockPurple } from 'images/setting/clock-purple.svg';
import { ReactComponent as IconDeleteRed } from 'images/general/delete-red.svg';
import { ReactComponent as IconCode } from 'images/general/code.svg';

import { ReactComponent as IconFlagsIr } from 'images/flag/ir.svg';
import { ReactComponent as IconFlagsUk } from 'images/flag/uk.svg';
import { ReactComponent as IconFlagsArIQ } from 'images/flag/ar-IQ.svg';



import './AppSettings.scss'

export default function AppSettings({ swController, showSecondsInLog, setShowSecondsInLog, showDeleteAllDevicesButton, setShowDeleteAllDevicesButton }) {
    const p = useContext(CurrentPageContext);
    const dismissHandler = p.dismiss;

    const l = useContext(LocalizationContext);
    const s = l.strings;

    const wm = useContext(WebViewManagerContext);

    const [popupId, showPopup, dismissPopup] = usePopup();

    return (
        <div className="app-settings-page">
            <div className="bg-blank" />
            <div className="bg-secondary-color" />
            <div className="app-settings-page-content">
                <CustomIconBack className="nav-icon" /> <div className="nav-button" onClick={dismissHandler} />
                <div className="header">{s.appSettings}</div>

                {/* <div className="section-header" style={{ marginBottom: 8 }}>{s.advancedOptions}</div> */}
                <div className="section-header">{s.generalOptions}</div>
                <div className="setting-cell app-settings-box" onClick={swController.reloadForUpdate}>
                    <IconReload className="setting-cell-icon" />
                    <div className="setting-cell-title">{s.reload}</div>
                </div>
                <div className="setting-cell app-settings-box" onClick={showPopup}>
                    <IconClearData className="setting-cell-icon" />
                    <div className="setting-cell-title">{s.clearData}</div>
                </div>

                <div className="section-header">{s.advancedOptions}</div>
                <div className="setting-cell app-settings-box" onClick={swController.askPushPermission}>
                    <IconNotif className="setting-cell-icon" />
                    <div className="setting-cell-title">{s.getPushPermission}</div>
                </div>
                <div className="setting-cell app-settings-box">
                    <IconClockPurple className="setting-cell-icon" />
                    <div className="setting-cell-title">{s.showSecondsInLog}</div>
                    <div />
                    <Toggle
                        enable={showSecondsInLog}
                        onClick={() => { setShowSecondsInLog(!showSecondsInLog) }}
                        customHeadIconType={ToggleHeadIconType.checkOrX} />
                </div>
                <div className="setting-cell app-settings-box">
                    <IconClearData className="setting-cell-icon" />
                    <div className="setting-cell-title">{s.showDeleteAllDevicesButton}</div>
                    <div />
                    <Toggle
                        enable={showDeleteAllDevicesButton}
                        onClick={() => { setShowDeleteAllDevicesButton(!showDeleteAllDevicesButton) }}
                        customHeadIconType={ToggleHeadIconType.checkOrX} />
                </div>

                {wm.webViewState.inWebView ?
                    <div className="setting-cell app-settings-box">
                        <IconCode className="setting-cell-icon" />
                        <div className="setting-cell-title">{s.enableDevTools}</div>
                        <div />
                        <Toggle
                            enable={wm.devTools}
                            onClick={() => { wm.setDevTools(!wm.devTools) }}
                            customHeadIconType={ToggleHeadIconType.checkOrX} />
                    </div>
                    : null}

                <Popup popupId={popupId} name="clear_data_popup" baseZIndex={12}>
                    <div className="clear-data-popup">
                        <div className="header">{s.clearDataConfirmAreYouSure}</div>
                        <div className="buttons-group">
                            <div className="delete-button" onClick={() => {
                                window.localStorage.clear();
                                window.location.reload();
                            }}>
                                <div className="label">{s.clearDataConfirmOK}</div>
                                <IconDeleteRed className="icon" />
                            </div>
                            <div className="dismiss-button" onClick={dismissPopup}>{s.clearDataConfirmNO}</div>
                        </div>
                    </div>
                </Popup>
            </div>
        </div>
    )
}

export function LanguagePopoverContentOnCreateProfilePage({ dismissHandler, setFullLanguage }) {
    const l = useContext(LocalizationContext);
    const s = l.strings;

    return (
        <div className="app-settings-page">
            <div className="bg-blank" />
            <div className="bg-secondary-color" />
            <div className="app-settings-page-content">
                <IconBack className="nav-icon" /> <div className="nav-button" onClick={dismissHandler} />
                <div className="header">{s.changeLanguage}</div>

                <div className="language-box-en" onClick={() => { setFullLanguage('en'); }}>
                    <IconFlagsUk className="language-icon" />
                    <div className={(l.fullLanguage === 'en') ? "label selected" : "label"}>English</div>
                    <div />
                    {(l.fullLanguage === 'en') ? <IconTick className="tick-icon" /> : null}
                </div>
                <div className="language-box-ar" onClick={() => { setFullLanguage('ar-IQ'); }}>
                    <IconFlagsArIQ className="language-icon" />
                    <div className={(l.fullLanguage === 'ar-IQ') ? "label selected" : "label"}>العربية العراقية</div>
                    <div />
                    {(l.fullLanguage === 'ar-IQ') ? <IconTick className="tick-icon" /> : null}
                </div>
                <div className="language-box-fa" onClick={() => { setFullLanguage('fa'); }}>
                    <IconFlagsIr className="language-icon" />
                    <div className={(l.fullLanguage === 'fa') ? "label selected" : "label"}>فارسی</div>
                    <div />
                    {(l.fullLanguage === 'fa') ? <IconTick className="tick-icon" /> : null}
                </div>
            </div>
        </div>
    )
}
